import Vue from "vue";
import { creatInterval } from "./publicFunction";

export function openSuccessInit(vueSelf) {
  let ws = vueSelf.$store.getters.myWebSocket;
  clearTimeout(vueSelf.$store.getters.timerMyWebSocketTimeOut);
  vueSelf.$store.commit('TIMER_MYWEBSOCKET_TIMEOUT', null);
  let bind_msg = {
    role: 'web',
    from: 'bind_user',
    data: {
      user_id: vueSelf.$cookies.get('user_id'),
      token: vueSelf.$cookies.get('token')
    }
  };
  ws.send(JSON.stringify(bind_msg));
  let heartPackage = {
    role: 'web',
    from: 'heart_package',
    data: {
      userId: Vue.$cookies.get('user_id'),
      token: Vue.$cookies.get('token')
    }
  };
  creatInterval(() => {
      ws.send(JSON.stringify(heartPackage));
    }, 50000, vueSelf);
  // let timerMyWebSocketHeart = setInterval(() => {
  //   console.log('setInterval----------->', 1111111111111111);
  //   ws.send(JSON.stringify(heartPackage));
  // }, 1500);
  // vueSelf.$store.commit('TIMER_MYWEBSOCKET_HEART', timerMyWebSocketHeart);
}
